import { appApi } from '@/app/redux/appApi';
import upgradeReducer from '@/app/redux/slices/upgradeSlice';
import { saveToLocalStorage } from '@/common/utils/localStorage';
import {
  combineReducers,
  configureStore,
  createListenerMiddleware,
  isAnyOf,
} from '@reduxjs/toolkit';
import bulkAddReducer from './slices/bulkAddSlice';
import insightsReducer, {
  setSelectedGroupIds,
  setSelectedStudentIds,
  setSelectedTab,
} from './slices/insightsSlice';
import modalsReducer from './slices/modalsSlice';
import sessionReducer from './slices/sessionSlice';
import shareLinkReducer from './slices/shareLinkSlice';

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(setSelectedStudentIds, setSelectedGroupIds, setSelectedTab),
  effect: (_action, listenerApi) => {
    const { insights } = listenerApi.getState() as RootState;
    saveToLocalStorage('insights', insights);
  },
});

const appReducer = combineReducers({
  session: sessionReducer,
  modals: modalsReducer,
  bulkAdd: bulkAddReducer,
  insights: insightsReducer,
  upgrade: upgradeReducer,
  shareLink: shareLinkReducer,

  [appApi.reducerPath]: appApi.reducer,
});

export const store = configureStore({
  reducer: appReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(appApi.middleware)
      .concat(listenerMiddleware.middleware),
});

export type AppStore = typeof store;
export type RootState = ReturnType<typeof appReducer>;
export type AppDispatch = typeof store.dispatch;
